import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ASSETS } from "@/lib/site";
import Reveal from "./Reveal";

export default function ValveShowcase() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const rotate = useTransform(scrollYProgress, [0, 1], [-6, 4]);
  const glow = useTransform(scrollYProgress, [0, 0.5, 1], [0.15, 0.4, 0.15]);

  return (
    <section
      ref={ref}
      id="valve"
      data-testid="valve-section"
      className="relative overflow-hidden bg-[#050505] py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        {/* text */}
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#169ED9]">
              / The Device
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Leak SmartShield by GWA Water Solutions
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-white/60 leading-relaxed max-w-md">
              Using award-winning technology developed through research at the
              University of Washington and Georgia Tech, it continuously monitors
              your plumbing, detects leaks, identifies unusual water use, and can
              automatically shut off your supply if a major leak occurs.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-white/40 text-sm leading-relaxed max-w-md">
              As one of the first plumbing companies in Australia to supply and
              install this innovative technology, we&apos;re proud to offer a smarter way
              to protect your home from costly water damage.
            </p>
          </Reveal>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            {[
              ["24/7", "Monitoring"],
              ["<2s", "Auto Shut-off"],
              ["AI", "Leak Detection"],
            ].map(([n, l], i) => (
              <Reveal key={l} delay={0.2 + i * 0.08}>
                <div className="border-l border-white/10 pl-4">
                  <div className="font-heading font-bold text-2xl text-[#169ED9]">{n}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/40 mt-1">
                    {l}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* video */}
        <div className="lg:col-span-7 order-1 lg:order-2 relative">
          <motion.div
            style={{ opacity: glow }}
            className="pointer-events-none absolute inset-0 bg-[#00E5FF]/30 blur-[120px] rounded-full"
          />
          <motion.div style={{ y: imgY, rotate }} className="relative">
            <video
              src={ASSETS.deviceVideo}
              poster="/assets/LDU-poster.jpg"
              data-testid="valve-device-video"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              className="mx-auto max-h-[620px] w-full h-auto object-contain rounded-2xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
